import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=0a600c0f&"
import script from "./Index.ts?vue&type=script&lang=js&"
export * from "./Index.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports